module.exports = __webpack_public_path__ + "assets/img/LTC041.dd53aa92.png";